// @flow

import { action, observable } from "mobx";

import Store from "app/stores/Store";
import AppearanceStore from "app/stores/AppearanceStore";

import GlobalSettingsService from "app/services/GlobalSettingsService";

class GlobalSettingsStore extends Store {
    @observable screenshotEngine: string;
    @observable videoCardTheme: string;
    @observable logo: string;
    @observable requireEarlyAccess: boolean;
    @observable cardSwitcherEffect: string;
    @observable newItemFollowEffect: string;
    @observable defaultTheme: string;
    @observable mediaRecordingAudioDurationLimit: number;
    @observable mediaRecordingVideoDurationLimit: number;

    @action setAll(settings: { [_: string]: any }) {
        for (let key in settings) {
            // $FlowFixMe
            this[key] = settings[key];
        }

        this.requireEarlyAccess = this.requireEarlyAccess === "1";
        this.mediaRecordingAudioDurationLimit = Number(
            this.mediaRecordingAudioDurationLimit
        );
        this.mediaRecordingVideoDurationLimit = Number(
            this.mediaRecordingVideoDurationLimit
        );
    }

    /*
     * Save
     */
    @action.bound update(param: string, value: any) {
        // $FlowFixMe
        const oldValue = this[param];

        // $FlowFixMe
        this[param] = value;

        GlobalSettingsService.update(param, value).then(
            ({ data }) => {
                AppearanceStore.notifySuccess(data.message);
            },
            ({ response }: any) => {
                AppearanceStore.notifyError(response.data.message);

                // $FlowFixMe
                this[param] = oldValue;
            }
        );
    }
}

export default new GlobalSettingsStore();



// WEBPACK FOOTER //
// ./src/app/stores/GlobalSettingsStore.js